var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data.advanceSale)?_c('div',{staticClass:"delivery"},[_c('img',{class:['pre-tag'],style:({ marginLeft: _vm.union_isBilingual ? '-10px' : '' }),attrs:{"src":_vm.union_isBilingual || _vm.CookiesOne && _vm.CookiesOne == 'en-US'
          ? require('@/assets/images/productDetail/pre-tag-en.png')
          : require('@/assets/images/productDetail/pre-tag.png'),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("\n      "+_vm._s(`${_vm.TLang('现在下单','list')}，${new Date(_vm.data.sendGoodsTimeStart)
          .toLocaleDateString()
          .replace(/\//g, "-")}${_vm.TLang('起开始发货','list')}`)+"\n    ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }